export default "__VITE_PUBLIC_ASSET__cf050ad1__"